<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "ProductsCategory",
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let category = ref([])
    let loading = ref(false)


    function load_category() {

      loading.value = true

      FreeWorld.Heisenberg({}, 'User_categories').then((result) => {

        loading.value = false
        category.value = result.data

      }).catch((result) => {

        loading.value = false
        Swals.Catch(result, load_category)
      })

    }

    load_category()


    return {
      category,
      loading,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p class="m-0">
        دسته بندی های فروشگاه
      </p>

      <div onclick="window.history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>

    <div v-if="category[0] == null " class="animate__animated animate__fadeIn p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-4 ">
          در حال حاضر دسته بندی وجود ندارد...
        </p>
      </div>
    </div>

    <div v-else class="div_cat p-body ">

      <router-link v-for="item in category" :key="item.id"
                   :to="{name:'ProductsSubCategory', params:{'cat_id': item.id}}"
                   class="animate__animated animate__fadeIn d-flex p-2 align-items-center mb-3 mx-1 text-decoration-none flex-column p-1 bg-white align-items-center rounded-3 item_cat">

        <div class="animated-background icon_cat mb-2 rounded-2">
          <img class="icon_cat rounded-2" :src="item.pic" alt="">
        </div>
        <p class="font-5 text-center m-0">{{ item.name }}</p>

      </router-link>

    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div v-if="category[0] == null" class="animate__animated animate__fadeIn p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-3 ">
          در حال حاضر دسته بندی وجود ندارد...
        </p>
      </div>
    </div>

    <div v-else class="d-flex justify-content-center">
      <div class="div_cat p-body">

        <router-link v-for="item in category" :key="item.id" :to="{name:'ProductsSubCategory', params:{'cat_id': item.id}}"
                     class="animate__animated animate__fadeIn d-flex p-2 align-items-center mb-3 mx-1 text-decoration-none flex-column p-1 bg-white align-items-center rounded-3 item_cat_web">

          <div class="animated-background w-100 h-90 mb-2 rounded-2">
            <img class="w-100 h-100 rounded-2" :src="item.pic" alt="">
          </div>
          <p class="font-4 text-center m-0">{{ item.name }}</p>

        </router-link>

      </div>
    </div>


    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>
.item_cat {
  flex-grow: 0;
  flex-basis: 30%;
}
.item_cat_web {
  flex-grow: 0;
  width: 12.3rem;
  min-height: 10rem;
}

@media (max-width: 1300px) {
  .item_cat_web{
    width: 10rem;
    min-height: 10rem;
  }
}


.div_cat {
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  direction: rtl;
}

.icon_cat {
  width: 100%;
  height: 90px;
}

</style>